import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getSlashCommandId } from '../TeamChat.utils';

import {
  commandDescriptionStyles,
  commandLabelStyles,
  focusedItemStyles,
  itemStyles,
  rootStyles,
} from './TeamChatSlashCommandSuggestions.styles';

const TeamChatSlashCommandSuggestions = memo(
  ({ commands, focusedCommandId = null, onSelectCommand, isHidden = false }) => {
    const onItemMouseDown = useCallback(
      command => e => {
        e.preventDefault();
        onSelectCommand(command);
      },
      [onSelectCommand],
    );

    if (isHidden || !commands.length) {
      return null;
    }

    return (
      <Box sx={rootStyles}>
        {commands.map(command => {
          const commandId = getSlashCommandId(command);
          const isFocused = commandId === focusedCommandId;

          return (
            <Box
              key={commandId}
              sx={isFocused ? focusedItemStyles : itemStyles}
              onMouseDown={onItemMouseDown(command)}
            >
              <Typography sx={commandLabelStyles} variant="medium14">
                {command.label}
              </Typography>
              <Typography sx={commandDescriptionStyles} variant="regular12">
                {command.description}
              </Typography>
            </Box>
          );
        })}
      </Box>
    );
  },
);
TeamChatSlashCommandSuggestions.propTypes = {
  commands: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectCommand: PropTypes.func.isRequired,
  focusedCommandId: PropTypes.string,
  isHidden: PropTypes.bool,
};

export default TeamChatSlashCommandSuggestions;
